import { useContext, useEffect, useState } from 'react'
import Layout from "../../components/layout"
import { Wrapper } from './style'
import { Checkbox } from '../../components/Checkbox'
import Input from '../../components/Input'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../../context/auth'
import { updateItemsToCartApi, deleteItemsFromCartApi, createCartApi, getCartApi, calculateTaxApi, getRegionsApi, removeDiscountFromCartApi, updateCartApi } from '../../api'
import { setLocalStorage, getLocalStorage, removeLocalStorage } from '../../helpers/localStorage'
import { useGtag } from '../../hooks/useGtag'

const Index = () => {
    const { isLoggedIn, setSignInModal, user, setSignUpModal, cartData, setNotification, setIsLoading, setCartData } = useContext(AuthContext)
    const { gtagViewCart, gtagRemoveFromCart } = useGtag()
    const cartId = getLocalStorage('cartId')
    const navigate = useNavigate()
    const [quantity, setQuantity] = useState(1)
    const [isAgree, setIsAgree] = useState(false)
    const [regions, setRegions] = useState([])
    const [couponCode, setCouponCode] = useState('')
    let isUpdatingItem = false;

    useEffect(() => {
        if (cartData && cartData?.items?.length > 0) {
            setQuantity(cartData?.items?.reduce((acc, curr) => acc + curr?.quantity, 0))
        }
    }, [cartData])

    const fetchRegions = () => {
        getRegionsApi().then(res => {
            if (res && res.data && res.data.regions) {
                setRegions(res.data.regions)
            }
        })
    }

    const calculateTax = () => {
        calculateTaxApi(cartData?.id).then((res) => {
            if (res && res.data && res.data.cart) {
                setCartData(res.data.cart)
            }
        })
    }


    useEffect(() => {
        if (!cartId) {
            createCartApi().then(res => {
                setLocalStorage('cartId', res.data.cart.id)
            })
        }
        else if (cartId) {
            getCartApi(cartId).then((res) => {
                if (res && res.data && res.data.cart) {
                    setCartData(res.data.cart)
                } else {
                    setCartData(null)
                }
            })
        }
    }, [cartId])


    const updateItem = async (itemId, quantity) => {
        if (isUpdatingItem) return;

        isUpdatingItem = true;
        setIsLoading(true);

        try {
            const res = await updateItemsToCartApi(cartData?.id, itemId, {
                quantity: quantity,
            });

            if (res.data?.cart) {
                if (user?.customer?.is_tax_exempt) {
                setCartData(res.data.cart);
                } else {
                    calculateTax();
                }
                const updatedItem = res.data.cart.items.find(item => item.id === itemId);
                gtagViewCart(res?.data?.cart?.subtotal, updatedItem)
                setNotification({
                    type: 'success',
                    message: 'Item Quantity updated'
                });
            } else {
                setNotification({
                    type: 'red',
                    message: 'Something went wrong, please try again!'
                });
            }
        } catch (error) {
            setNotification({
                type: 'red',
                message: 'Something went wrong, please try again!'
            });
        } finally {
            setIsLoading(false);
            isUpdatingItem = false;
        }
    };


    const removeItem = (itemId) => {
        setIsLoading(true)
        deleteItemsFromCartApi(cartData?.id, itemId).then((res) => {
            if (res.data?.cart) {
                if (user?.customer?.is_tax_exempt) {
                    setCartData(res.data?.cart)
                } else {
                    calculateTax()
                }
                const updatedItem = res.data.cart.items.find(item => item.id === itemId);
                gtagViewCart(res?.data?.cart?.subtotal, updatedItem)
                gtagRemoveFromCart(res?.data?.cart?.subtotal)
                setNotification({
                    type: 'success',
                    message: 'Item Removed from cart'
                })
                setIsLoading(false)
            } else {
                setNotification({
                    type: 'red',
                    message: 'Something went wrong, please try again!'
                })
                setIsLoading(false)
            }
        }).catch(() => {
            setNotification({
                type: 'red',
                message: 'Something went wrong, please try again!'
            })
            setIsLoading(false)
        })
    }

    const removeDiscount = () => {
        setIsLoading(true)
        removeDiscountFromCartApi(cartData?.id, cartData?.discounts[0]?.code)
            .then((res) => {
                setCartData(res?.data?.cart)
                setIsLoading(false)
            }).catch((err) => {
                setNotification({
                    type: 'red',
                    message: 'Something went wrong, please try again!'
                })
                setIsLoading(false)
            })
    }

    const addDiscount = () => {
        updateCartApi(cartData?.id, {
            discounts: [{
                code: couponCode
            }]
        }).then((res) => {
            if (res?.data?.cart) {
                setCartData(res?.data?.cart)
                setIsLoading(false)
                setNotification({
                    type: 'success',
                    message: 'Discount Coupon Applied'
                })
                setCouponCode('')
            }
        }).catch((err) => {
            setNotification({
                type: 'red',
                message: err?.message || 'Something went wrong, please try again!'
            })
            setIsLoading(false)
        })
    }

    const clearCart = () => {
        setIsLoading(true)
        setCartData(null)
        removeLocalStorage('cartId', null)
        createCartApi().then(res => {
            setLocalStorage('cartId', res.data.cart.id)
            setIsLoading(false)
        })
    }


    return (
        <Layout>
            <Wrapper>
                <div className='header'>
                <h3>Cart</h3>
                {!!cartData?.items?.length && 
                <button className='btn transparent' onClick={clearCart}>Clear Cart</button>
                }
                </div>
                {cartData?.items && cartData?.items?.length > 0 ?
                    <div className="content">
                        <div className="left-container">
                            <div className="items-container">
                                {cartData?.items?.sort((a, b) => {
                                    if (a.variant_id === b.variant_id) {
                                        const aFree = a.metadata?.is_bogo_free === true
                                        const bFree = b.metadata?.is_bogo_free === true

                                        if (aFree && !bFree) return 1
                                        if (!aFree && bFree) return -1

                                        return new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
                                    }
                                    return a.title.localeCompare(b.title)
                                }).map((item) => {
                                    return <div className="item" key={item.id}>
                                        <div className="item-content">
                                            {item?.mid_code?.search('SA') < 0 ? <h4>{item.variant.product.title}, {item.variant.product.metadata.subclass}</h4>
                                                : <h4>{item.variant.product.title}</h4>
                                            }
                                            <div className="item-details">
                                                <div className="details">
                                                    <h6>Cat ID#</h6>
                                                    <h5>{item.variant.product.mid_code} {item.variant.product.material}</h5>
                                                </div>
                                                <div className="details">
                                                    <h6>Concentration</h6>
                                                    <h5>{item.variant.product.concentration} mg/ml</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="quantity-content">
                                            <button className='quantity-btn' style={{ width: '40px', height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#EDEDED', color: '#DC1E00', cursor: 'pointer', opacity: item.quantity > 1 ? 1 : 0.4, pointerEvents: item.quantity > 1 ? 'auto' : 'none' }}
                                                onClick={() => {
                                                    if (item.quantity > 1) {
                                                        updateItem(item.id, item.quantity - 1)
                                                    }
                                                    else {
                                                        // removeItem(item.id)
                                                    }
                                                }}
                                            >
                                                <i className="far fa-minus"></i>
                                            </button>
                                            <span className='quantity'>{item.quantity}</span>
                                            <button className='quantity-btn' style={{ width: '40px', height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#EDEDED', color: '#DC1E00', cursor: item?.metadata?.is_bogo_free ? 'default' : 'pointer' }}
                                                onClick={() => {
                                                    updateItem(item.id, item.quantity + 1)
                                                }}
                                            >
                                                <i className="far fa-plus"></i>
                                            </button>
                                        </div>
                                        <div className="price-content">
                                            <h4>${(item.subtotal / 100).toFixed(2)}</h4>
                                            {item.quantity > 1 && <h6>${(item.unit_price / 100).toFixed(2)} x {item.quantity}</h6>}
                                            {item?.adjustments[0]?.metadata?.freeQty && (
                                                <h6 className='free'>{item.adjustments[0].metadata.freeQty} item{item.adjustments[0].metadata.freeQty > 1 ? 's' : ''} free</h6>
                                            )}
                                        </div>
                                        <button style={{ width: '40px', height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '12px', background: '#EDEDED', color: '#DC1E00', cursor: item?.metadata?.is_bogo_free ? 'default' : 'pointer' }} className='delete-item quantity-btn'
                                            disabled={item?.metadata?.is_bogo_free}
                                            onClick={() => removeItem(item.id)}
                                        >
                                            <i className="far fa-trash-alt"></i>
                                        </button>
                                    </div>
                                })}
                            </div>
                        </div>
                        <div className="right-container">
                            <h4>Summary</h4>
                            <div className="price-summary">
                                <div className="price">
                                    <p>{quantity} Items</p>
                                    <p>${(cartData?.subtotal / 100)?.toFixed(2)}</p>
                                </div>
                                <div className="price">
                                    <p>Tax</p>
                                    <p>${(cartData?.tax_total / 100)?.toFixed(2)}</p>
                                </div>
                                {cartData?.discounts?.length > 0 &&
                                    <div className='price'>
                                        <p>Discount Coupon (<span style={{ fontWeight: 700 }}>{cartData.discounts[0].code}</span>) <i className='fas fa-times' style={{ cursor: 'pointer' }} onClick={removeDiscount} /></p>
                                        <p>-${(cartData?.discount_total / 100)?.toFixed(2)}</p>
                                    </div>
                                }
                                <hr />
                                <div className="price">
                                    <p>Grand Total</p>
                                    <p style={{ fontWeight: 700 }}>${((cartData?.total - cartData?.shipping_total) / 100)?.toFixed(2)}</p>
                                </div>
                            </div>
                            {!cartData?.discounts?.length && (
                                <div className='coupon-container'>
                                    <p>Have a coupon code?</p>
                                    <div className='coupon-form'>
                                        <Input className='coupon-input' style={{ flex: 1 }} placeholder='Enter Coupon Code' value={couponCode} onChange={(e) => setCouponCode(e.target.value)} />
                                        <button className='btn transparent'
                                            disabled={!couponCode}
                                            onClick={addDiscount}
                                        >Apply</button>
                                    </div>
                                </div>
                            )}
                            <Checkbox label='I have read and agreed to the' higlighted='Terms and Conditions of Sale'
                                checked={isAgree}
                                onChange={() => setIsAgree(!isAgree)}
                                higlightedLink={() => navigate("/terms-and-conditions-of-sale")}
                            />
                            <button className='btn'
                                disabled={!isAgree}
                                onClick={() => isLoggedIn ? (!user?.customer?.shipping_addresses?.length || !user?.customer?.billing_address || user?.customer?.is_tax_exempt === null || !user?.customer?.metadata?.is_email_verified) ? setSignUpModal(true) :
                                    navigate("/checkout") : setSignInModal(true)}
                            >Proceed To Checkout</button>
                        </div>
                    </div>
                    :
                    <div className='no-orders'>
                        <span className='icon'>
                            <i className="fal fa-boxes"></i>
                        </span>
                        <p>No items added to the cart yet.</p>
                    </div>
                }
            </Wrapper>
        </Layout>
    )
}

export default Index